export default __webpack_public_path__ + "static/media/screen1.c5c1fe66.png";